import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { 
  CreditCard, Wallet, Smartphone, Truck, 
  Calendar, Clock, MessageSquare, Package,
  Shield, Gift, CheckCircle, MapPin, User, Phone, Mail,
  AlertCircle, Info, Edit2
} from 'lucide-react';
import { useCart } from '../context/CartContext';

const Checkout = () => {
  const { cart, addons, orderMessage, setOrderMessage, clearCart, getCartTotal, updateCustomMessage } = useCart();
  const navigate = useNavigate();
  
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    alterphone: '',
    email: '',
    address: '',
    city: '',
    pincode: '',
    deliveryDate: '',
    deliveryTime: '',
    paymentMethod: 'cod'
  });
  
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);
  const [deliveryChecked, setDeliveryChecked] = useState(false);
  const [deliveryInfo, setDeliveryInfo] = useState(null);
  const [showProductMessages, setShowProductMessages] = useState(false);
  const [productMessages, setProductMessages] = useState({});

  // Time slot charges
  const timeSlotCharges = {
    '9-12': 0,    // Morning slot - no charge
    '12-3': 50,   // Afternoon slot - ₹50 extra
    '3-6': 100,   // Evening slot - ₹100 extra
    '6-9': 150    // Night slot - ₹150 extra
  };


// 8kNBAB5NDVGZiUnBf80D30yo

const openRazorpay = (orderData) => {
  const options = {
    key: "rzp_live_RwwteyzfiZA7oG",  
    amount: 1 * 100, // paise me
    currency: "INR",
    name: "Sohkin",
    description: "Order Payment",
    image: "", // optional
    handler: function (response) {
      // ✅ Payment success
      const paidOrder = {
        ...orderData,
        paymentId: response.razorpay_payment_id,
        status: "confirmed",
        paidAt: new Date().toISOString()
      };

      // save order
      const orders = JSON.parse(localStorage.getItem("sohkinOrders") || "[]");
      orders.push(paidOrder);
      localStorage.setItem("sohkinOrders", JSON.stringify(orders));

      sessionStorage.setItem("lastOrder", JSON.stringify(paidOrder));

      clearCart();
      navigate(`/order-confirmation/${orderData.orderId}`);
    },
    prefill: {
      name: orderData.customer.name,
      email: orderData.customer.email,
      contact: orderData.customer.phone
    },
    theme: {
      color: "#db2777" // pink theme
    }
  };

  const rzp = new window.Razorpay(options);
  rzp.open();
};









  // Initialize product messages from cart
  useEffect(() => {
    const initialMessages = {};
    cart.forEach(item => {
      if (item.allowCustomMessage) {
        initialMessages[`${item.type}-${item.id}`] = item.customMessage || '';
      }
    });
    setProductMessages(initialMessages);
  }, [cart]);

  const validateForm = () => {
    const newErrors = {};
    
    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.phone.match(/^[6-9]\d{9}$/)) newErrors.phone = 'Valid 10-digit mobile number required';
    if (!formData.email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) newErrors.email = 'Valid email required';
    if (!formData.address.trim()) newErrors.address = 'Address is required';
    if (!formData.city.trim()) newErrors.city = 'City is required';
    if (!formData.pincode.match(/^\d{6}$/)) newErrors.pincode = 'Valid 6-digit pincode required';
    
    // Check if all products with allowCustomMessage have messages
    cart.forEach(item => {
      if (item.allowCustomMessage) {
        const key = `${item.type}-${item.id}`;
        if (!productMessages[key]?.trim()) {
          newErrors.productMessages = 'Please add custom messages for products that require them';
        }
      }
    });
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validateForm()) {
      return;
    }

    if (!deliveryChecked) {
      alert('Please check delivery availability for your pincode');
      return;
    }

    setLoading(true);

    try {
      // Calculate time slot charge
      const timeSlotCharge = timeSlotCharges[formData.deliveryTime] || 0;
      
      // Generate order ID
      const orderId = `ORD${Date.now()}${Math.floor(Math.random() * 1000)}`;
      
      // Update cart items with custom messages
      const updatedCart = cart.map(item => {
        const key = `${item.type}-${item.id}`;
        const customMessage = productMessages[key] || item.customMessage || '';
        updateCustomMessage(item.id, item.type, customMessage);
        return { ...item, customMessage };
      });

      // Prepare order data
      const orderData = {
        orderId,
        customer: formData,
        delivery: {
          ...deliveryInfo,
          timeSlot: formData.deliveryTime,
          timeSlotCharge
        },
        items: [
          ...updatedCart.map(item => ({
            id: item.id,
            type: item.type,
            name: item.name,
            price: item.finalPrice || item.price,
            quantity: item.quantity,
            customMessage: item.customMessage || '',
            selectedOption: item.selectedOption || null,
            allowCustomMessage: item.allowCustomMessage || false
          })),
          ...addons.map(addon => ({
            id: addon.id,
            type: 'addon',
            name: addon.name,
            price: addon.price,
            quantity: addon.quantity,
            description: addon.description
          }))
        ],
        summary: {
          subtotal: getCartTotal(),
          shipping: getCartTotal() > 999 ? 0 : 99,
          timeSlotCharge,
          total: getCartTotal() + (getCartTotal() > 999 ? 0 : 99) + timeSlotCharge,
          itemsCount: updatedCart.reduce((sum, item) => sum + item.quantity, 0) + 
                     addons.reduce((sum, addon) => sum + addon.quantity, 0)
        },
        message: orderMessage,
        status: formData.paymentMethod === 'cod' ? 'confirmed' : 'pending',
        paymentMethod: formData.paymentMethod,
        createdAt: new Date().toISOString()
      };

      // // Save order to localStorage
      // const orders = JSON.parse(localStorage.getItem('sohkinOrders') || '[]');
      // orders.push(orderData);
      // localStorage.setItem('sohkinOrders', JSON.stringify(orders));

      // // Save to session for confirmation page
      // sessionStorage.setItem('lastOrder', JSON.stringify(orderData));

      // // Clear cart
      // clearCart();

      // // Redirect to confirmation
      // navigate(`/order-confirmation/${orderId}`);






// if (formData.paymentMethod === "cod") {
//   // COD flow (same as abhi)
//   const orders = JSON.parse(localStorage.getItem('sohkinOrders') || '[]');
//   orders.push(orderData);
//   localStorage.setItem('sohkinOrders', JSON.stringify(orders));

//   sessionStorage.setItem('lastOrder', JSON.stringify(orderData));
//   clearCart();
//   navigate(`/order-confirmation/${orderId}`);
// } else {
  // 🔥 ONLINE PAYMENT (Razorpay)
  openRazorpay(orderData);
// }









      
    } catch (error) {
      console.error('Error placing order:', error);
      alert('Error placing order. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  const handleCheckDelivery = async () => {
    if (!formData.pincode.match(/^\d{6}$/)) {
      setErrors({ ...errors, pincode: 'Valid 6-digit pincode required' });
      return;
    }

    try {
      const response = await fetch('/data/pincodes.json');
      const data = await response.json();
      const found = data.pincodes.find(p => p.pincode === formData.pincode);
      
      if (found && found.deliveryAvailable) {
        setDeliveryChecked(true);
        setDeliveryInfo(found);
        setFormData(prev => ({ ...prev, city: found.city }));
        alert(`Delivery available to ${found.city}. Estimated delivery in ${found.deliveryDays} day(s).`);
      } else {
        setDeliveryChecked(false);
        setDeliveryInfo(null);
        alert('Delivery not available for this pincode');
      }
    } catch (error) {
      alert('Error checking delivery');
    }
  };

  const calculateTotal = () => {
    const total = getCartTotal();
    const shipping = total > 999 ? 0 : 99;
    const timeSlotCharge = timeSlotCharges[formData.deliveryTime] || 0;
    return total + shipping + timeSlotCharge;
  };

  const getTimeSlotLabel = (slot) => {
    const labels = {
      '9-12': '9 AM - 12 PM',
      '12-3': '12 PM - 3 PM',
      '3-6': '3 PM - 6 PM',
      '6-9': '6 PM - 9 PM'
    };
    return labels[slot] || slot;
  };

  const handleProductMessageChange = (key, value) => {
    setProductMessages(prev => ({
      ...prev,
      [key]: value
    }));
  };

  if (cart.length === 0) {
    return (
      <div className="min-h-screen bg-gradient-to-b from-white to-pink-50 flex items-center justify-center py-8 px-4">
        <div className="text-center max-w-sm">
          <Package className="h-16 w-16 text-gray-300 mx-auto mb-4" />
          <h2 className="text-xl font-bold mb-3 text-gray-900">Your cart is empty</h2>
          <p className="text-gray-600 text-sm mb-6">Add items to your cart before checkout</p>
          <button
            onClick={() => navigate('/shop')}
            className="bg-pink-600 text-white px-6 py-3 rounded-lg font-medium hover:bg-pink-700"
          >
            Continue Shopping
          </button>
        </div>
      </div>
    );
  }

  // Check if any product requires custom message
  const hasCustomMessageProducts = cart.some(item => item.allowCustomMessage);

  return (
    <div className="min-h-screen bg-gradient-to-b from-white to-pink-50 py-4">
      <div className="container mx-auto px-3">
        <h1 className="text-xl font-bold text-gray-900 mb-6">Checkout</h1>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* Left Column - Form */}
          <div className="lg:col-span-2">
            <form onSubmit={handleSubmit} className="space-y-6">
              {/* Delivery Information */}
              <div className="bg-white rounded-xl shadow-sm p-4">
                <h2 className="text-lg font-bold mb-4 flex items-center gap-2">
                  <MapPin className="h-5 w-5 text-pink-600" />
                  Delivery Information
                </h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Full Name *
                    </label>
                    <div className="relative">
                      <User className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                      <input
                        type="text"
                        value={formData.name}
                        onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-pink-500"
                        placeholder="Enter Recipient's name"
                      />
                    </div>
                    {errors.name && <p className="text-red-500 text-xs mt-1">{errors.name}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Phone Number *
                    </label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                      <input
                        type="tel"
                        value={formData.phone}
                        onChange={(e) => setFormData({ ...formData, phone: e.target.value.replace(/\D/g, '') })}
                        maxLength={10}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-pink-500"
                        placeholder="10-digit mobile number"
                      />
                    </div>
                    {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
                  </div>
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Alter Phone Number *
                    </label>
                    <div className="relative">
                      <Phone className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                      <input
                        type="tel"
                        value={formData.alterphone}
                        onChange={(e) => setFormData({ ...formData, alterphone: e.target.value.replace(/\D/g, '') })}
                        maxLength={10}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-pink-500"
                        placeholder="10-digit Alternative mobile number"
                      />
                    </div>
                    {errors.phone && <p className="text-red-500 text-xs mt-1">{errors.phone}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email Address *
                    </label>
                    <div className="relative">
                      <Mail className="absolute left-3 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-400" />
                      <input
                        type="email"
                        value={formData.email}
                        onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                        className="w-full pl-10 pr-3 py-2 border border-gray-300 rounded-lg focus:outline-none focus:border-pink-500"
                        placeholder="your@email.com"
                      />
                    </div>
                    {errors.email && <p className="text-red-500 text-xs mt-1">{errors.email}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Pincode *
                    </label>
           <div className="flex flex-col gap-2">
  <input
    type="text"
    value={formData.pincode}
    onChange={(e) =>
      setFormData({
        ...formData,
        pincode: e.target.value.replace(/\D/g, '').slice(0, 6),
      })
    }
    className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-pink-500"
    placeholder="6-digit pincode"
    maxLength={6}
  />

  <button
    type="button"
    onClick={handleCheckDelivery}
    className="bg-pink-600 text-white px-4 py-2 rounded-lg hover:bg-pink-700 text-sm w-full"
  >
    Check
  </button>
</div>

                    {errors.pincode && <p className="text-red-500 text-xs mt-1">{errors.pincode}</p>}
                    {deliveryChecked && (
                      <p className="text-green-600 text-xs mt-1 flex items-center">
                        <CheckCircle className="h-3 w-3 mr-1" />
                        Delivery available to {formData.city}
                      </p>
                    )}
                  </div>

                  <div className="md:col-span-2">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Complete Address *
                    </label>
                    <textarea
                      value={formData.address}
                      onChange={(e) => setFormData({ ...formData, address: e.target.value })}
                      rows={3}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-pink-500"
                      placeholder="House no, Building, Street, Area"
                    />
                    {errors.address && <p className="text-red-500 text-xs mt-1">{errors.address}</p>}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      City *
                    </label>
                    <input
                      type="text"
                      value={formData.city}
                      onChange={(e) => setFormData({ ...formData, city: e.target.value })}
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-pink-500"
                      placeholder="Enter your city"
                    />
                    {errors.city && <p className="text-red-500 text-xs mt-1">{errors.city}</p>}
                  </div>
                </div>
              </div>

              {/* Delivery Schedule */}
              <div className="bg-white rounded-xl shadow-sm p-4">
                <h2 className="text-lg font-bold mb-4 flex items-center gap-2">
                  <Calendar className="h-5 w-5 text-pink-600" />
                  Delivery Schedule
                </h2>
                
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Preferred Date *
                    </label>
                    <input
                      type="date"
                      value={formData.deliveryDate}
                      onChange={(e) => setFormData({ ...formData, deliveryDate: e.target.value })}
                      min={new Date().toISOString().split('T')[0]}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-pink-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-2">
                      Preferred Time Slot *
                    </label>
                    <select
                      value={formData.deliveryTime}
                      onChange={(e) => setFormData({ ...formData, deliveryTime: e.target.value })}
                      required
                      className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-pink-500"
                    >
                      <option value="">Select Time Slot</option>
                      {Object.entries(timeSlotCharges).map(([slot, charge]) => (
                        <option key={slot} value={slot}>
                          {getTimeSlotLabel(slot)} {charge > 0 && `(+₹${charge})`}
                        </option>
                      ))}
                    </select>
                    
                    {formData.deliveryTime && timeSlotCharges[formData.deliveryTime] > 0 && (
                      <div className="mt-2 p-2 bg-yellow-50 border border-yellow-200 rounded-lg">
                        <div className="flex items-center gap-2 text-yellow-700 text-sm">
                          <Info className="h-4 w-4" />
                          <span>Extra charge of ₹{timeSlotCharges[formData.deliveryTime]} for this time slot</span>
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <div className="mt-4 grid grid-cols-2 md:grid-cols-4 gap-2">
                  {Object.entries(timeSlotCharges).map(([slot, charge]) => (
                    <div 
                      key={slot}
                      className={`p-3 border rounded-lg cursor-pointer transition-all ${
                        formData.deliveryTime === slot 
                          ? 'border-pink-500 bg-pink-50' 
                          : 'border-gray-300 hover:border-pink-300'
                      }`}
                      onClick={() => setFormData(prev => ({ ...prev, deliveryTime: slot }))}
                    >
                      <div className="text-center">
                        <div className="font-medium text-sm">{getTimeSlotLabel(slot)}</div>
                        <div className={`text-xs mt-1 ${charge > 0 ? 'text-pink-600' : 'text-green-600'}`}>
                          {charge > 0 ? `+₹${charge}` : 'No Charge'}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Product Custom Messages */}
              {hasCustomMessageProducts && (
                <div className="bg-white rounded-xl shadow-sm p-4">
                  <div className="flex items-center justify-between mb-4">
                    <h2 className="text-lg font-bold flex items-center gap-2">
                      <MessageSquare className="h-5 w-5 text-pink-600" />
                      Product Custom Messages *
                    </h2>
                    <button
                      type="button"
                      onClick={() => setShowProductMessages(!showProductMessages)}
                      className="text-pink-600 hover:text-pink-700 text-sm flex items-center gap-1"
                    >
                      <Edit2 className="h-4 w-4" />
                      {showProductMessages ? 'Hide' : 'Edit'}
                    </button>
                  </div>
                  
                  {errors.productMessages && (
                    <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg">
                      <div className="flex items-center gap-2 text-red-700 text-sm">
                        <AlertCircle className="h-4 w-4" />
                        <span>{errors.productMessages}</span>
                      </div>
                    </div>
                  )}

                  {showProductMessages ? (
                    <div className="space-y-4">
                      {cart
                        .filter(item => item.allowCustomMessage)
                        .map(item => {
                          const key = `${item.type}-${item.id}`;
                          return (
                            <div key={key} className="p-3 border border-gray-200 rounded-lg">
                              <div className="flex items-start gap-3 mb-3">
                                <img
                                  src={item.image}
                                  alt={item.name}
                                  className="w-12 h-12 object-cover rounded"
                                />
                                <div className="flex-1">
                                  <h3 className="font-medium text-sm">{item.name}</h3>
                                  <p className="text-gray-600 text-xs">Quantity: {item.quantity}</p>
                                </div>
                              </div>
                              <textarea
                                value={productMessages[key] || ''}
                                onChange={(e) => handleProductMessageChange(key, e.target.value)}
                                rows={2}
                                className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-pink-500 text-sm"
                                placeholder={`Write a custom message for ${item.name}...`}
                                maxLength={150}
                              />
                              <div className="flex justify-between mt-2">
                                <span className="text-xs text-gray-500">
                                  This message will be included specifically with this item
                                </span>
                                <span className="text-xs text-gray-500">
                                  {productMessages[key]?.length || 0}/150
                                </span>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  ) : (
                    <div className="space-y-2">
                      {cart
                        .filter(item => item.allowCustomMessage)
                        .map(item => {
                          const key = `${item.type}-${item.id}`;
                          const message = productMessages[key] || item.customMessage || '';
                          return (
                            <div key={key} className="flex items-start gap-3 p-3 bg-gray-50 rounded-lg">
                              <img
                                src={item.image}
                                alt={item.name}
                                className="w-10 h-10 object-cover rounded"
                              />
                              <div className="flex-1">
                                <div className="font-medium text-sm">{item.name}</div>
                                <div className="text-gray-600 text-xs mt-1">
                                  {message ? `"${message}"` : 'No message added'}
                                </div>
                              </div>
                            </div>
                          );
                        })}
                    </div>
                  )}
                </div>
              )}

              {/* Gift Message */}
              <div className="bg-white rounded-xl shadow-sm p-4">
                <h2 className="text-lg font-bold mb-4 flex items-center gap-2">
                  <Gift className="h-5 w-5 text-pink-600" />
                  Gift Card Message (Optional)
                </h2>
                <textarea
                  value={orderMessage}
                  onChange={(e) => setOrderMessage(e.target.value)}
                  rows={3}
                  className="w-full border border-gray-300 rounded-lg px-3 py-2 focus:outline-none focus:border-pink-500"
                  placeholder="Write a personal message for the gift card..."
                  maxLength={200}
                />
                <p className="text-gray-500 text-xs mt-2">
                  This message will be printed on a beautiful greeting card included with your order.
                </p>
              </div>

              {/* Payment Method */}
              <div className="bg-white rounded-xl shadow-sm p-4">
                <h2 className="text-lg font-bold mb-4 flex items-center gap-2">
                  <CreditCard className="h-5 w-5 text-pink-600" />
                  Payment Method *
                </h2>
                
                <div className="space-y-3">
         

                  <label className="flex items-center p-3 border border-gray-300 rounded-lg hover:border-pink-500 cursor-pointer">
                    <input
                      type="radio"
                      name="payment"
                      value="upi"
                      checked={formData.paymentMethod === 'upi'}
                      onChange={(e) => setFormData({ ...formData, paymentMethod: e.target.value })}
                      className="h-4 w-4 text-pink-600"
                    />
                    <div className="ml-3 flex items-center gap-3">
                      <Smartphone className="h-5 w-5 text-purple-600" />
                      <div>
                        <div className="font-medium">UPI</div>
                        <div className="text-sm text-gray-600">Pay using UPI apps</div>
                      </div>
                    </div>
                  </label>
                </div>

                <div className="mt-4 flex items-center gap-2 text-sm text-green-600">
                  <Shield className="h-4 w-4" />
                  <span>100% Secure Payment</span>
                </div>
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={loading}
                className="w-full bg-pink-600 text-white py-3 rounded-lg font-semibold hover:bg-pink-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                {loading ? 'Placing Order...' : `Place Order - ₹${calculateTotal()}`}
              </button>
            </form>
          </div>

          {/* Right Column - Order Summary */}
          <div className="lg:col-span-1">
            <div className="bg-white rounded-xl shadow-sm p-6 sticky top-4">
              <h2 className="text-lg font-bold mb-6">Order Summary</h2>
              
              {/* Items List */}
              <div className="space-y-3 max-h-64 overflow-y-auto mb-4">
                {cart.map(item => (
                  <div key={`${item.type}-${item.id}`} className="flex justify-between text-sm">
                    <div>
                      <div className="font-medium">{item.name} × {item.quantity}</div>
                      {item.selectedOption && (
                        <div className="text-xs text-gray-500">
                          {Object.keys(item.selectedOption)[0]}
                        </div>
                      )}
                    </div>
                    <div className="font-semibold">₹{(item.finalPrice || item.price) * item.quantity}</div>
                  </div>
                ))}
                
                {addons.map(addon => (
                  <div key={addon.id} className="flex justify-between text-sm">
                    <div>
                      <div className="font-medium text-gray-600">{addon.name} × {addon.quantity}</div>
                    </div>
                    <div className="font-semibold">₹{addon.price * addon.quantity}</div>
                  </div>
                ))}
              </div>

              {/* Price Breakdown */}
              <div className="border-t pt-4 space-y-2">
                <div className="flex justify-between">
                  <span>Subtotal</span>
                  <span>₹{getCartTotal()}</span>
                </div>
                <div className="flex justify-between">
                  <span>Shipping</span>
                  <span>{getCartTotal() > 999 ? 'FREE' : '₹99'}</span>
                </div>
                
                {/* Time Slot Charge */}
                {formData.deliveryTime && timeSlotCharges[formData.deliveryTime] > 0 && (
                  <div className="flex justify-between text-yellow-600">
                    <span>Time Slot ({getTimeSlotLabel(formData.deliveryTime)})</span>
                    <span>+₹{timeSlotCharges[formData.deliveryTime]}</span>
                  </div>
                )}

                <div className="border-t pt-3 flex justify-between text-lg font-bold">
                  <span>Total</span>
                  <span className="text-pink-600">₹{calculateTotal()}</span>
                </div>
              </div>

              {/* Delivery Info */}
              {deliveryInfo && (
                <div className="mt-4 p-3 bg-green-50 border border-green-200 rounded-lg">
                  <div className="flex items-center gap-2 mb-1">
                    <CheckCircle className="h-4 w-4 text-green-600" />
                    <span className="text-sm font-medium text-green-800">Delivery Available</span>
                  </div>
                  <div className="text-xs text-green-700">
                    To {deliveryInfo.city} in {deliveryInfo.deliveryDays} day(s)
                  </div>
                </div>
              )}

              {/* Product Messages Summary */}
              {hasCustomMessageProducts && (
                <div className="mt-4 p-3 bg-blue-50 border border-blue-200 rounded-lg">
                  <div className="flex items-center gap-2 mb-2">
                    <MessageSquare className="h-4 w-4 text-blue-600" />
                    <span className="text-sm font-medium text-blue-800">Custom Messages</span>
                  </div>
                  <div className="text-xs text-blue-700">
                    {cart.filter(item => item.allowCustomMessage).length} product(s) require custom messages
                  </div>
                </div>
              )}

              {/* Notes */}
              <div className="mt-6 space-y-2 text-xs text-gray-500">
                <div className="flex items-center gap-2">
                  <Truck className="h-3 w-3" />
                  <span>Free shipping on orders above ₹999</span>
                </div>
                <div className="flex items-center gap-2">
                  <Gift className="h-3 w-3" />
                  <span>Free gift wrapping included</span>
                </div>
                <div className="flex items-center gap-2">
                  <Shield className="h-3 w-3" />
                  <span>7-day freshness guarantee</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Checkout;